export default function icon (svgMarkup, options = {}) {
  let label, styleClass;
  if (typeof options === 'string') {
    label = options;
  } else {
    label = options.label;
    styleClass = options.styleClass;
  }

  const svg = new DOMParser().parseFromString(svgMarkup, 'image/svg+xml');
  const svgEl = svg.documentElement;

  if (styleClass) {
    svgEl.setAttribute('class', `d-icon ${styleClass}`);
  } else {
    svgEl.setAttribute('class', 'd-icon');
  }

  if (label) {
    svgEl.setAttribute('aria-label', label);
  } else {
    svgEl.setAttribute('aria-hidden', true);
  }

  return svgEl;
}
